import React from 'react';
import { storiesOf } from '@storybook/react';
import DocketHeader from './DocketHeader';
import DocketFilters from './DocketFilters';
import PropTypes from 'prop-types';

storiesOf('Docket/DocketFilters', module)
  .add('Empty', () =>
    <DocketFilters {...props} />)

const props = {
  keyword: null,
  doc_range: null,
  changeDate: () => null,
  onChangeDateRaw: () => null,
  onChange: () => null,
  onClear: () => null,
  getFilteredDockets: () => null,
  date_filed_from: null,
  date_filed_to: null,
};


const mockHeaderData = {
  "assigned_to": "Judge Randall L. Dunn",
  "attorneys": [
    {
      "associated": [
        {
          "address": "419 Main Street\nOregon City, OR 97045\nCLACKAMAS-OR",
          "ein": "93-1293801",
          "name": "Blue Heron Paper Company",
          "role": "Debtor"
        }
      ],
      "attorney": {
        "address": "600 University St #3600\nSeattle, WA 98101",
        "name": "DAVID B LEVANT",
        "phone": "206-386-7601"
      }
    },
    {
      "associated": [
        {
          "address": "419 Main Street\nOregon City, OR 97045\nCLACKAMAS-OR",
          "ein": "93-1293801",
          "name": "Blue Heron Paper Company",
          "role": "Debtor"
        }
      ],
      "attorney": {
        "address": "900 SW 5th Ave #2600\nPortland, OR 97204",
        "name": "BRANDY A SARGENT",
        "phone": "503-224-3380"
      }
    },
    {
      "associated": [
        {
          "address": "419 Main Street\nOregon City, OR 97045\nCLACKAMAS-OR",
          "ein": "93-1293801",
          "name": "Blue Heron Paper Company",
          "role": "Debtor"
        }
      ],
      "attorney": {
        "address": "900 SW Fifth Ave #2600\nPortland, OR 97204",
        "name": "GARVEY SCHUBERT",
        "phone": "503-224-3380"
      }
    },
    {
      "associated": [
        {
          "address": "419 Main Street\nOregon City, OR 97045\nCLACKAMAS-OR",
          "ein": "93-1293801",
          "name": "Blue Heron Paper Company",
          "role": "Debtor"
        }
      ],
      "attorney": {
        "address": "319 SW Washington #520\nPortland, OR 97204",
        "name": "ROBERT J VANDEN BOS",
        "phone": "503-241-4869"
      }
    },
    {
      "associated": [
        {
          "address": "515 NW Saltzman Rd.\nPMB #917\nPortland, OR 97229",
          "name": "Peter C McKittrick",
          "phone": "503-616-4979",
          "role": "Trustee"
        }
      ],
      "attorney": {
        "address": "101 SW Main #1100\nPortland, OR 97204",
        "name": "DAVID W CRISWELL",
        "phone": "503-228-2525"
      }
    },
    {
      "associated": [
        {
          "address": "515 NW Saltzman Rd.\nPMB #917\nPortland, OR 97229",
          "name": "Peter C McKittrick",
          "phone": "503-616-4979",
          "role": "Trustee"
        }
      ],
      "attorney": {
        "address": "101 SW Main St #1100\nPortland, OR 97204",
        "name": "MATHEW W LAURITSEN",
        "phone": "503-228-2525"
      }
    },
    {
      "associated": [
        {
          "address": "515 NW Saltzman Rd.\nPMB #917\nPortland, OR 97229",
          "name": "Peter C McKittrick",
          "phone": "503-616-4979",
          "role": "Trustee"
        }
      ],
      "attorney": {
        "address": "111 SW Columbia, Ste 1100\nPortland, OR 97201",
        "name": "JUSTIN D LEONARD",
        "phone": "971-634-0192"
      }
    },
    {
      "associated": [
        {
          "address": "515 NW Saltzman Rd.\nPMB #917\nPortland, OR 97229",
          "name": "Peter C McKittrick",
          "phone": "503-616-4979",
          "role": "Trustee"
        }
      ],
      "attorney": {
        "address": "101 SW Main #1100\nPortland, OR 97204",
        "name": "BRAD T SUMMERS",
        "phone": "503-228-2525"
      }
    },
    {
      "associated": [
        {
          "address": "c/o Michael R. Riley\n303 W. Madison St\nChicago, IL 60603\nx 1310",
          "name": "National Fiber Supply",
          "phone": "312-346-4800",
          "role": "Creditor Committee",
          "terminated_date": "05/25/2011"
        }
      ],
      "attorney": {
        "address": "62 SW Morrison St #1225\nPortland, OR 97205\n1orbtester+",
        "email": "70@gmail.com",
        "name": "JOSEPH Aorb FIELD",
        "phone": "503-228-9115",
        "terminated_date": "05/25/2011"
      }
    },
    {
      "associated": [
        {
          "address": "2125 SE 76th Ave\nPortland, OR 97215",
          "name": "Committee of Retired Employees",
          "phone": "503-775-8243",
          "role": "Creditor Committee"
        }
      ],
      "attorney": {
        "address": "15545 Village Park Ct\nLake Oswego, OR 97034",
        "name": "BRADLEY O BAKER",
        "phone": "503-697-0557"
      }
    }
  ],
  "chapter": "7",
  "date_filed": "12/31/2009",
  "filing_claims_deadline": "08/08/2011",
  "has_asset": 1,
  "header_html_timestamp": "2019-09-05T16:06:35Z",
  "html": "<TABLE  class=\"DktRpt\"  width=\"100%\" align=right BORDER=0 CELLSPACING=5><TR><TD ALIGN=right><h2> <FONT SIZE=\"3\">APPEAL, CONVERTED, DENYDISCH522q1</FONT></h2></TD></TR></TABLE><BR><BR><BR><CENTER><B><FONT SIZE=\"+1\">U.S. Bankruptcy Court<BR>District of Oregon (Portland)<BR>Bankruptcy Petition #: 09-40921-rld7</FONT></B></CENTER><TABLE  class=\"DktRpt\"  width=\"100%\" BORDER=0 CELLSPACING=1><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><BR><I>Assigned to:</I>      Judge Randall L. Dunn<BR>Chapter          7<BR>Previous chapter 11<BR>Voluntary<BR>Asset <br><div class=\"noprint\"><A HREF='/cgi-bin/qryAscCases.pl?381842'>Show Associated Cases</A></div> <div class=\"noprint\"><a href='/cgi-bin/SearchClaims.pl?caseid=381842;sc'>Claims Register</a></div><BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"50%\" ALIGN=right><FONT SIZE=\"+0\"><TABLE  class=\"DktRpt\"  border=0 cellspacing=0 cellpadding=0 align=center><TR><td align=\"right\" valign=\"top\"><I>Date filed:</I></td><td align=\"left\" valign=\"top\">&nbsp;&nbsp;12/31/2009</td></TR><TR><td align=\"right\" valign=\"top\"><I>Date converted:</I></td><td align=\"left\" valign=\"top\">&nbsp;&nbsp;04/01/2011</td></TR><TR><td align=\"right\" valign=\"top\"><I>341 meeting:</I></td><td align=\"left\" valign=\"top\">&nbsp;&nbsp;05/10/2011</td></TR><TR><td align=\"right\" valign=\"top\"><I>Deadline for filing claims:</I></td><td align=\"left\" valign=\"top\">&nbsp;&nbsp;08/08/2011  </td></TR><TR><td align=\"right\" valign=\"top\"><I>Deadline for objecting to discharge:</I></td><td align=\"left\" valign=\"top\">&nbsp;&nbsp;07/11/2011  </td></TR></TABLE>\t</FONT></TD>\n</TR>\n</TABLE><BR><FONT SIZE=\"5\"><B></B>\n\t\t</FONT><TABLE  class=\"DktRpt\"  width=\"100%\" BORDER=0 CELLSPACING=1><TR><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Debtor</B></I><BR><B>Blue Heron Paper Company</B>\n<BR>419 Main Street\n<BR>Oregon City, OR 97045\n<BR>CLACKAMAS-OR\n<BR>Tax ID / EIN: 93-1293801     <BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  ALIGN=right><FONT SIZE=\"+0\">represented by\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\">\n  \t                    <font size=\"+0\"><B>DAVID B LEVANT</B>\n<BR>600 University St &#035;3600\n<BR>Seattle, WA 98101\n<BR>(206) 386-7601<BR><BR><B>BRANDY A SARGENT</B>\n<BR>900 SW 5th Ave &#035;2600\n<BR>Portland, OR 97204\n<BR>(503) 224-3380<BR><BR><B>GARVEY SCHUBERT</B>\n<BR>900 SW Fifth Ave &#035;2600\n<BR>Portland, OR 97204\n<BR>(503) 224-3380<BR><BR><B>ROBERT J VANDEN BOS</B>\n<BR>319 SW Washington &#035;520\n<BR>Portland, OR 97204\n<BR>(503) 241-4869<BR><BR></font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Trustee</B></I><BR><B>Peter C McKittrick</B>\n<BR>515 NW Saltzman Rd.\n<BR>PMB &#035;917\n<BR>Portland, OR 97229\n<BR>(503) 616-4979<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  ALIGN=right><FONT SIZE=\"+0\">represented by\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\">\n  \t                    <font size=\"+0\"><B>DAVID W CRISWELL</B>\n<BR>101 SW Main &#035;1100\n<BR>Portland, OR 97204\n<BR>(503) 228-2525<BR><BR><B>MATHEW W LAURITSEN</B>\n<BR>101 SW Main St &#035;1100\n<BR>Portland, OR 97204\n<BR>(503) 228-2525<BR><BR><B>JUSTIN D LEONARD</B>\n<BR>111 SW Columbia, Ste 1100\n<BR>Portland, OR 97201\n<BR>(971) 634-0192<BR><BR><B>BRAD T SUMMERS</B>\n<BR>101 SW Main &#035;1100\n<BR>Portland, OR 97204\n<BR>(503) 228-2525<BR><BR></font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>U.S. Trustee</B></I><BR><B>US Trustee, Portland</B>\n<BR>620 SW Main St &#035;213\n<BR>Portland, OR 97205\n<BR>(503) 326-4000<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Cred. Comm. Chair</B></I><BR><B>Weyerhaeuser</B>\n<BR>c/o Linda Fornero\n<BR>CH2E30 P.O. Box 9777\n<BR>Federal Way, WA 98063\n<BR>253-924-7176<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Metro Waste Paper Recovery, Inc.</B>\n<BR>c/o Ken Rasmussen\n<BR>12345 104 Ave.\n<BR>Surrey, BC V3V3H2\n<BR>604-580-3070<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Ashland, Inc.</B>\n<BR>c/o Terry Nicholson\n<BR>5200 Blazer Parkway\n<BR>Dublin, OH 43017\n<BR>614-790-3009<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Nationwide Magazine Recycling, Inc.</B>\n<BR>c/o Roy Threlkeld\n<BR>2300 Apollo Circle\n<BR>Carrollton, TX 75006\n<BR>972-416-9599<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>National Fiber Supply</B>\n<BR>c/o Michael R. Riley\n<BR>303 W. Madison St\n<BR>Chicago, IL 60603\n<BR>312-346-4800 x 1310\n<BR><I> TERMINATED: 05/25/2011</I><BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  ALIGN=right><FONT SIZE=\"+0\">represented by\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\">\n  \t                    <font size=\"+0\"><B>JOSEPH Aorb FIELD</B>\n<BR>62 SW Morrison St &#035;1225\n<BR>Portland, OR 97205\n<BR>(503) 228-9115\n<BR>Email:&nbsp;<a href='mailto:1orbtester+70@gmail.com'>1orbtester+70@gmail.com</a>\n<BR><I> TERMINATED: 05/25/2011</I><BR><BR></font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Demitrakikes Trucking, Inc.</B>\n<BR>c/o Denise Thornton\n<BR>P.O. Box 381\n<BR>Canby, OR 97013\n<BR>503-266-9265<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Pacific Fibre Products</B>\n<BR>c/o Don Lightfoot\n<BR>PO Box 278\n<BR>Longview, WA 98632\n<BR>360-577-7112<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\" NOWRAP>\n  \t                    <font size=\"+0\">&nbsp;</font></TD><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>Committee of Retired Employees</B>\n<BR>2125 SE 76th Ave\n<BR>Portland, OR 97215\n<BR>(503) 775-8243<BR><BR>\t</FONT></TD>\n\t<TD VALIGN=top  ALIGN=right><FONT SIZE=\"+0\">represented by\t</FONT></TD>\n<TD valign=\"top\" WIDTH=\"40%\">\n  \t                    <font size=\"+0\"><B>BRADLEY O BAKER</B>\n<BR>15545 Village Park Ct\n<BR>Lake Oswego, OR 97034\n<BR>(503) 697-0557<BR><BR></font></TD></TR><TR>\t<TD VALIGN=top  WIDTH=\"50%\"><FONT SIZE=\"+0\"><I><B>Creditor Committee</B></I><BR><B>K&L Gates</B>\n<BR>Attn: R Gibson Masters\n<BR>1 SW Columbia St &#035;1900\n<BR>Portland, OR 97258-2041\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"20%\" ALIGN=right><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n\t<TD VALIGN=top  WIDTH=\"40%\"><FONT SIZE=\"+0\">&nbsp;\t</FONT></TD>\n</TR></TABLE><BR>",
  "is_header_html_valid": 1,
  "latest_docket_number": 1578,
  "latest_history_number": null,
  "latest_known_date_filed": "05/02/2019",
  "meeting_341": "05/10/2011",
  "modified": "2019-09-05T16:06:35.935260Z",
  "objecting_discharge_deadline": "07/11/2011",
  "trustees": [
    {
      "address": "515 NW Saltzman Rd.\nPMB #917\nPortland, OR 97229",
      "name": "Peter C McKittrick",
      "phone": "503-616-4979",
      "role": "Trustee"
    }
  ],
  "voluntary": 1
};


// WEBPACK FOOTER //
// ./src/components/case/docket/DocketFilters.stories.jsx